import {useQuery} from 'react-query';
import getInputUnits from '.';

const useGetInputUnits = (payload: IInputUnitsProps) => {
  const {data, isLoading} = useQuery(
    ['get-input-units', payload],
    () => getInputUnits(payload),
    {enabled: !!payload.input_guid},
  );

  return {unitData: data, unitsIsLoading: isLoading};
};

export default useGetInputUnits;
